/* eslint-disable */
import LocalStorageService from '../services/LocalStorageService'

export default {
  inserted: hasPermission,
  update: hasPermission
}

function hasPermission (el, bindings, vnode) {
  changeElement(commentElement(), vnode) // Init occulting element of DOM

  const decorator = vnode.componentInstance.$versionable.decorators.users
  const user = LocalStorageService.getUserDetails()
  const validPermissions = bindings.value.map( p => p.toUpperCase())

  const newNode = decorator.hasPermission(user, ...validPermissions) ? vnode.componentInstance.$el : commentElement()

  changeElement(newNode, vnode) // End setting the right element at DOM
}

/**
 * This method update the VNode element and the respective VNode element at DOM with 'newElement'
 * @param {HTMLElement} newElement
 * @param {VNode} vnode
 */
 function changeElement(newElement, vnode) {
  vnode.elm.parentNode?.replaceChild(newElement, vnode.elm)
  vnode.elm = newElement
}

function commentElement () { return document.createComment('') }
